import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "px-6 pt-2 gap-6 h-screen" }
const _hoisted_2 = { class: "w-full h-screen bg-white rounded-md pt-4" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "text-xl w-3/4 mx-auto my-8 opacity-60" }, "Converts natural language prompts into a visualized knowlege graph (text2graph)", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "my-2" }, "Please use your Google account to sign-in.", -1)
const _hoisted_5 = { class: "mt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GoogleLogin = _resolveComponent("GoogleLogin")!
  const _component_GraphList = _resolveComponent("GraphList")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_GoogleLogin)
        ]),
        _createVNode(_component_GraphList)
      ])
    ])
  ]))
}